import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import { Grid, Row, Col, Panel, Breadcrumb, ButtonToolbar, Button } from 'react-bootstrap';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import dateFilterRadios from '../Common/dateFilterRadios';
import { toFromDates } from '../../components/Common/cleanDates';
import { ROOT_URL, companyCodeTitle, isOLG, isGFD, isCTP } from '../../actions/root_url';

class PosHolds extends Component {
  constructor() {
    super();
    this.state = {
      status: 'all',
      FromDate: undefined,
      ToDate: undefined,
      days: '7',
      posHoldsTable: {
        rows: [],
        filters: {},
        selectedRows: [],
      },
      selectedRowIndex: null,
      selectedRowTable: {
        rows: [],
      },
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    this.props.fetchPosHoldsOrders(this.state, this.props.selectedCompany);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.posHolds) {
      this.setState({
        posHoldsTable: {
          ...this.state.posHoldsTable,
          rows: nextProps.posHolds.map(elem => ({
            ...elem,
            isSelected: false,
          })),
        },
      });
    }
    if (nextProps.posHoldsOderDetail) {
      this.setState({
        selectedRowTable: {
          rows: nextProps.posHoldsOderDetail.POS_Order_Lines,
        },
      });
    }
    if (nextProps.confirmPasscodeVerified) {
      this.props.setPasscodeVerificationStatus(false);
      this.props.voidSelectedPosHoldsOrder(this.state.posHoldsTable.selectedRows[0].HoldInvoice_id, () => {
        this.props.fetchPosHoldsOrders(this.state, this.props.selectedCompany);
        this.setState({
          posHoldsTable: {
            ...this.state.posHoldsTable,
            selectedRows: [],
          },
        });
      });
    }

    if ((isGFD || isCTP) && nextProps.selectedCompany && nextProps.selectedCompany !== this.props.selectedCompany) {
      this.props.fetchPosHoldsOrders(this.state, nextProps.selectedCompany);
    }
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({
      ToDate: e,
    });
  }

  setFromDate = (e) => {
    if (e < this.state.ToDate) {
      return;
    }
    this.setState({ FromDate: e });
  }

  setToRangeSearch = () => {
    this.setState({ days: '-1' });
  }

  fetchPosHoldsByDetails = (days) => {
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    if (this.state.FromDate != null) { FromDate = this.state.FromDate; }

    if (this.state.ToDate != null) { ToDate = this.state.ToDate; }
    if (days === '-1' || days === -1) {
      this.setState({ days }, () => {
        this.props.fetchPosHoldsOrders(this.state, this.props.selectedCompany);
      });
    } else {
      this.setState({ days, FromDate: undefined, ToDate: undefined }, () => {
        this.props.fetchPosHoldsOrders(this.state, this.props.selectedCompany);
      });
    }
  }

  renderTable = () => {
    const tableHeight = (window.innerHeight < 930) ? 285 : 285;

    const getRows = () => Data.Selectors.getRows(this.state.posHoldsTable);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onClearFilters = () => {
      // all filters removed
      const posHoldsTable = { ...this.state.posHoldsTable, filters: {} };
      this.setState({ posHoldsTable });
    };

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.posHoldsTable.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }

      this.setState({
        posHoldsTable: {
          ...this.state.posHoldsTable,
          filters: newFilters,
        },
      });
    };

    const onRowClick = (index) => {
      const rows = getRows();
      this.setState({
        selectedRowIndex: index,
      }, () => {
        this.props.fetchPosHoldsOrdersDetail(rows[index].HoldInvoice_id);
      })
    };

    const onRowSelect = (rows) => {
      this.setState({
        selectedRows: rows,
      })
    }

    const columns = [
      {
        key: 'Order_Num',
        name: <Translate value="order_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 135,
      },
      {
        key: 'Sales_User_Name',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
      },
      {
        key: 'Date',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CreditCardAmount',
        name: <Translate value="credit_card_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CheckAmount',
        name: <Translate value="check_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CashAmount',
        name: <Translate value="cash_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'StoreCreditAmount',
        name: <Translate value="store_credit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'MobileAmount',
        name: <Translate value="mobile_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'Note',
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
    ];

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [...this.state.posHoldsTable.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const posHoldsTable = { ...this.state.posHoldsTable, rows: newRows, selectedRows };
      this.setState({ posHoldsTable });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      const selectedRows = [...this.state.posHoldsTable.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = _.findIndex(selectedRows, { 'HoldInvoice_id': r.row.HoldInvoice_id });
        selectedRows.splice(rowIndex, 1);
      });
      const posHoldsTable = { ...this.state.posHoldsTable, rows: newRows, selectedRows };
      this.setState({ posHoldsTable });
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="PosOrders-dataGrid1">
            <ReactDataGrid
              rowKey="HoldInvoice_id"
              ref={ g => this.g = g }
              toolbar={<Toolbar enableFilter />}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              enableRowSelect="multi"
              onRowClick={onRowClick}
              // onRowSelect={onRowSelect}
              rowSelection={{
                showCheckbox: true,
                enableShiftSelect: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderDetailTable = () => {
    const tableHeight = (window.innerHeight < 930) ? 285 : 285;

    const getRows = () => Data.Selectors.getRows(this.state.selectedRowTable);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const columns = [
      ...isOLG ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'Quantity',
        name: <Translate value="quantity" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'TotalNetWeight',
        name: <Translate value="total_wt" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'UnitPrice',
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
    ];

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="posHolds_id"
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const { FromDate, ToDate, days } = this.state;
    const dates = toFromDates(days, FromDate, ToDate);
    const params = `Date__gte=${dates.fromDate}&Date__lte=${dates.toDate}`;
    let excelUrl = `${ROOT_URL}v1/pos/hold_orders/?Bearer=${localStorage.getItem('token')}&filename=holds&${params}`;
    let company = this.props.selectedCompany.value ? this.props.selectedCompany.value : this.props.selectedCompany;
    if (isGFD || isCTP) {
      excelUrl = `${ROOT_URL}v1/pos/hold_orders/?Bearer=${localStorage.getItem('token')}&filename=holds&${params}&Company_id=${company}`;
    }
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="pos_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="pos_holds" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="sales-orders-list">
          <h1><Translate value="pos_holds_full_table" /></h1>
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={2}>
                    <h3 className="filter-title"><Translate value="order_date" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={10}>
                    {
                      dateFilterRadios({
                        handleOnClick: this.fetchPosHoldsByDetails,
                        setFromDate: this.setFromDate,
                        setToDate: this.setToDate,
                        setToRangeSearch: this.setToRangeSearch,
                        FromDate: this.state.FromDate,
                        ToDate: this.state.ToDate,
                        Days: this.state.days,
                      })
                    }
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="details-table-collapse-fix">
                <Row>
                  <Col xs={12}>
                    <ButtonToolbar className="table-buttons" style={{ position: 'absolute', marginLeft: '7px' }}>
                      <Button
                        bsStyle="success"
                        type="button"
                        href={excelUrl}
                      >
                        <em className="fa fa-download" /><Translate value="export" />
                      </Button>
                      <Button
                        bsStyle="danger"
                        type="button"
                        disabled={this.state.posHoldsTable.selectedRows.length !== 1}
                        onClick={() => {
                          this.props.setConfirmPasscodeModalVisibility(true);
                        }}
                      >
                        <em className="fa fa-trash" /><Translate value="void" />
                      </Button>
                    </ButtonToolbar>
                    {this.renderTable()}
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <Row style={{ marginTop: '30px' }}>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={12}>
                    {this.renderDetailTable()}
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default PosHolds;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/posHolds.jsx